// src/lib/shuffle.js
//
// Fisher-Yates on a copy; the input is never changed. `random` is a parameter so
// the order can be tested without luck (used by the Overheard rows, ticket 25).
export function shuffled(list, random = Math.random) {
  const out = [...list];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
